import React from 'react';

import { ColorScheme } from '~/design-tokens/themes/themes';

import * as S from './Loading.styles';

interface LoadingProps {
  className?: string;
  colorScheme?: ColorScheme;
}

export const Loading = ({
  className,
  colorScheme = ColorScheme.Dark,
}: LoadingProps) => (
  <S.Loader data-testid="loading-view" className={className}>
    <S.InnerBox>
      <S.LogoBox>
        <img
          data-testid="loading-logo"
          src={`/app/static/images/brand/logo-${colorScheme}.svg`}
          alt="logo"
        />
      </S.LogoBox>
      <S.ProgressBar>
        <S.ProgressBarMeter />
      </S.ProgressBar>
    </S.InnerBox>
  </S.Loader>
);
